import { render } from "./CourseDetailsPage.vue?vue&type=template&id=070d6732&scoped=true"
import script from "./CourseDetailsPage.vue?vue&type=script&lang=js"
export * from "./CourseDetailsPage.vue?vue&type=script&lang=js"

import "./CourseDetailsPage.vue?vue&type=style&index=0&id=070d6732&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070d6732"]])

export default __exports__